module.exports = __webpack_public_path__ + "img/m-arrow-right-grey-default.74df6afa.svg";